import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Lightbulb } from 'lucide-react';
import useAuthStore from '../../store/authStore';
import { SECTIONS, sectionFor } from './sections';

const LABEL = {
  '': 'dashboard', 'warehouses': 'warehouses', 'raw-materials': 'raw_materials', 'finished-goods': 'finished_goods',
  'inventory': 'inventory', 'production': 'production', 'purchases': 'purchases', 'sales': 'sales',
  'lading-bills': 'lading_bills', 'transfers': 'transfers', 'accounting': 'accounting', 'reports': 'reports',
  'users': 'users', 'audit-log': 'audit_log', 'shipments': 'shipments', 'misc-goods': 'misc_goods',
  'costing': 'costing', 'expenses': 'expenses', 'prepayments': 'prepayments', 'payroll': 'payroll', 'import': 'import_data', 'report-builder': 'report_builder', 'chat': 'chat',
};

export default function SectionFooter({ pathname }) {
  const { t, i18n } = useTranslation();
  const canRoute = useAuthStore(s => s.canRoute);
  useAuthStore(s => s.user);   // re-render when permissions change
  const sec = sectionFor(pathname);
  const related = sec.related.filter(p => SECTIONS[p] && canRoute('/' + p));
  const lang = i18n.language;
  const today = new Date().toLocaleDateString(lang === 'fa' ? 'fa-IR-u-ca-persian' : lang === 'ru' ? 'ru-RU' : 'en-GB',
    { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  return (
    <footer className="sec-footer" style={{ '--sec': sec.accent }}>
      <div className="sec-footer-tip">
        <Lightbulb size={16} />
        <p>{t('tip_' + sec.key)}</p>
      </div>
      {related.length > 0 && (
        <nav className="sec-footer-links" aria-label={t('related_sections')}>
          <span>{t('related_sections')}</span>
          {related.map(p => (
            <Link key={p} to={'/' + p} style={{ '--to': SECTIONS[p].accent }}>{t(LABEL[p])}</Link>
          ))}
        </nav>
      )}
      <div className="sec-footer-meta">
        <span>{t('app_name')} 4.1.2</span>
        <span>{today}</span>
      </div>
    </footer>
  );
}
